var _path, _rect, _rect2, _rect3, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Phone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#184f85",
    d: "M36,40H12v3c0,1.105,0.895,2,2,2h20c1.105,0,2-0.895,2-2V40z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 7,
    x: 12,
    y: 33,
    fill: "#0078d4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 10,
    x: 12,
    y: 23,
    fill: "#1b9de2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 14,
    x: 12,
    y: 9,
    fill: "#35c1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M36,9H12V6c0-1.105,0.895-2,2-2h20c1.105,0,2,0.895,2,2V9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 6.5,
    r: 0.75,
    fill: "#0c63ad"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c63ad",
    d: "M27.5,5.75c-0.194,0-4.806,0-5,0c-0.414,0-0.75,0.336-0.75,0.75c0,0.414,0.336,0.75,0.75,0.75 c0.194,0,4.806,0,5,0c0.414,0,0.75-0.336,0.75-0.75C28.25,6.086,27.914,5.75,27.5,5.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Phone);
export default __webpack_public_path__ + "static/media/icons8-phone.508698839b606a4951ddf467f533179b.svg";
export { ForwardRef as ReactComponent };